import { v4 as uuidv4 } from 'uuid';

import { dispatchPromise, fetchResources } from './action-helpers';

const DEFAULT_EMBED_PROPS = {
    id: null,
    project: null,
    url: '',
    title: null,
    created_at: null
};

export const createEmbed = embedProps => {
    return dispatchPromise({
        type: 'EMBED_CREATE_REQUESTED',
        payload: {
            embed: Object.assign({}, DEFAULT_EMBED_PROPS, embedProps, {
                id: uuidv4(),
                created_at: new Date()
            })
        }
    });
}

export const fetchEmbeds = (fetchProps, all) => fetchResources('EMBEDS_FETCH_REQUESTED', fetchProps, all);

export const fetchEmbed = embedId => {
    return dispatchPromise({
        type: 'EMBED_FETCH_REQUESTED',
        payload: { embedId }
    });
}

export const updateEmbed = (embedId, embedProps, preventSave) => {
    return dispatchPromise({
        type: 'EMBED_UPDATE_REQUESTED',
        preventSave,
        payload: {
            embedId,
            embedProps
        }
    });
}

export const removeEmbed = embedId => {
    return dispatchPromise({
        type: 'EMBED_REMOVE_REQUESTED',
        payload: {
            embedId
        }
    });
}
